import { Location, NavigateFunction } from "react-router-dom"

type OnboardingState = Record<string, unknown> | null | undefined

export function scrubOnboardingLocationState(state: OnboardingState) {
  if (state == null) {
    return state
  }

  if (typeof state !== "object") {
    return state
  }

  const original = state as Record<string, unknown>
  const draft = { ...original }
  let mutated = false
  const removeKey = (key: string) => {
    if (key in draft) {
      delete draft[key]
      mutated = true
    }
  }

  removeKey("step")
  removeKey("forceRedirect")
  removeKey("forceKyc")
  removeKey("targetStep")
  removeKey("targetRecordedAt")
  removeKey("targetSource")

  if (!mutated) {
    return original
  }

  return Object.keys(draft).length > 0 ? draft : null
}

export function clearLocationState(navigate: NavigateFunction, location: Location) {
  try {
    const originalState = location.state as OnboardingState
    const cleanedState = scrubOnboardingLocationState(originalState)
    if (cleanedState === originalState) {
      return
    }
    navigate(location.pathname + location.search, {
      replace: true,
      state: cleanedState ?? null,
    })
  } catch (_) {
    // ignore
  }
}

// Finds highest accessible step <= target using provided canAccess function
export function resolveNearestAccessibleStep(target: number, canAccess: (s: number) => boolean): number {
  for (let i = target; i >= 1; i--) {
    if (canAccess(i)) return i
  }
  return 1
}

export function isValidStep(step: number, total: number) {
  return step >= 1 && step <= total
}

